// <zzy-empty title="..." message="..."></zzy-empty>
class ZzyEmpty extends HTMLElement {
  connectedCallback() {
    const title = this.getAttribute('title') || 'Sem dados';
    const message = this.getAttribute('message') || '';
    this.innerHTML = `
      <div style="
        background: var(--zzy-surface);
        border: 1px dashed var(--zzy-border);
        border-radius: var(--zzy-radius);
        padding: 40px;
        text-align: center;
      ">
        <div style="font:600 16px/1.2 var(--zzy-font);color:var(--zzy-text);margin-bottom:6px">${title}</div>
        ${message ? `<div style="font:400 13px/1.4 var(--zzy-font);color:var(--zzy-text-mute)">${message}</div>` : ''}
      </div>
    `;
  }
}
customElements.define('zzy-empty', ZzyEmpty);
